import {useMutation} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {GENERATE_QUESTION_WITH_SEED} from '../sharedQueries';

export interface GenerateQuestionWithSeedVariables {
  moduleId: string;
  topic?: string;
  seedQuestionId: string;
  variantCount?: number;
  numberOfVariants?: number;
  additionalInfo?: string;
}

export function useGenerateQuestionWithSeed() {
  const [generateQuestions, {loading, error}] = useMutation<
    {generateQuestionWithSeed: string[]},
    GenerateQuestionWithSeedVariables
  >(GENERATE_QUESTION_WITH_SEED);

  const generateQuestionWithSeed = async (variables: GenerateQuestionWithSeedVariables) => {
    const result = await generateQuestions({variables});
    return extractGqlData(result).generateQuestionWithSeed;
  };

  return {
    generateQuestionWithSeed,
    loading,
    error,
  };
}
